const han2zenEntries: [string, string][] = [
    ['!', '！'],
    ['"', '”'],
    ['#', '＃'],
    ['$', '＄'],
    ['%', '％'],
    ['&', '＆'],
    ['\'', '’'],
    ['(', '（'],
    [')', '）'],
    ['*', '＊'],
    ['+', '＋'],
    [',', '，'],
    ['-', '－'],
    ['.', '．'],
    ['/', '／'],
    ['0', '０'],
    ['1', '１'],
    ['2', '２'],
    ['3', '３'],
    ['4', '４'],
    ['5', '５'],
    ['6', '６'],
    ['7', '７'],
    ['8', '８'],
    ['9', '９'],
    [':', '：'],
    [';', '；'],
    ['<', '＜'],
    ['=', '＝'],
    ['>', '＞'],
    ['?', '？'],
    ['@', '＠'],
    ['A', 'Ａ'],
    ['B', 'Ｂ'],
    ['C', 'Ｃ'],
    ['D', 'Ｄ'],
    ['E', 'Ｅ'],
    ['F', 'Ｆ'],
    ['G', 'Ｇ'],
    ['H', 'Ｈ'],
    ['I', 'Ｉ'],
    ['J', 'Ｊ'],
    ['K', 'Ｋ'],
    ['L', 'Ｌ'],
    ['M', 'Ｍ'],
    ['N', 'Ｎ'],
    ['O', 'Ｏ'],
    ['P', 'Ｐ'],
    ['Q', 'Ｑ'],
    ['R', 'Ｒ'],
    ['S', 'Ｓ'],
    ['T', 'Ｔ'],
    ['U', 'Ｕ'],
    ['V', 'Ｖ'],
    ['W', 'Ｗ'],
    ['X', 'Ｘ'],
    ['Y', 'Ｙ'],
    ['Z', 'Ｚ'],
    ['[', '［'],
    ['\\', '￥'],
    [']', '］'],
    ['^', '＾'],
    ['_', '＿'],
    ['`', '‘'],
    ['a', 'ａ'],
    ['b', 'ｂ'],
    ['c', 'ｃ'],
    ['d', 'ｄ'],
    ['e', 'ｅ'],
    ['f', 'ｆ'],
    ['g', 'ｇ'],
    ['h', 'ｈ'],
    ['i', 'ｉ'],
    ['j', 'ｊ'],
    ['k', 'ｋ'],
    ['l', 'ｌ'],
    ['m', 'ｍ'],
    ['n', 'ｎ'],
    ['o', 'ｏ'],
    ['p', 'ｐ'],
    ['q', 'ｑ'],
    ['r', 'ｒ'],
    ['s', 'ｓ'],
    ['t', 'ｔ'],
    ['u', 'ｕ'],
    ['v', 'ｖ'],
    ['w', 'ｗ'],
    ['x', 'ｘ'],
    ['y', 'ｙ'],
    ['z', 'ｚ'],
    ['{', '｛'],
    ['|', '｜'],
    ['}', '｝'],
    ['~', '～'],
    ['｡', '。'],
    ['｢', '「'],
    ['｣', '」'],
    ['､', '、'],
    ['･', '・'],
    ['ｦ', 'ヲ'],
    ['ｧ', 'ァ'],
    ['ｨ', 'ィ'],
    ['ｩ', 'ゥ'],
    ['ｪ', 'ェ'],
    ['ｫ', 'ォ'],
    ['ｬ', 'ャ'],
    ['ｭ', 'ュ'],
    ['ｮ', 'ョ'],
    ['ｯ', 'ッ'],
    ['ｰ', 'ー'],
    ['ｱ', 'ア'],
    ['ｲ', 'イ'],
    ['ｳ', 'ウ'],
    ['ｴ', 'エ'],
    ['ｵ', 'オ'],
    ['ｶ', 'カ'],
    ['ｷ', 'キ'],
    ['ｸ', 'ク'],
    ['ｹ', 'ケ'],
    ['ｺ', 'コ'],
    ['ｻ', 'サ'],
    ['ｼ', 'シ'],
    ['ｽ', 'ス'],
    ['ｾ', 'セ'],
    ['ｿ', 'ソ'],
    ['ﾀ', 'タ'],
    ['ﾁ', 'チ'],
    ['ﾂ', 'ツ'],
    ['ﾃ', 'テ'],
    ['ﾄ', 'ト'],
    ['ﾅ', 'ナ'],
    ['ﾆ', 'ニ'],
    ['ﾇ', 'ヌ'],
    ['ﾈ', 'ネ'],
    ['ﾉ', 'ノ'],
    ['ﾊ', 'ハ'],
    ['ﾋ', 'ヒ'],
    ['ﾌ', 'フ'],
    ['ﾍ', 'ヘ'],
    ['ﾎ', 'ホ'],
    ['ﾏ', 'マ'],
    ['ﾐ', 'ミ'],
    ['ﾑ', 'ム'],
    ['ﾒ', 'メ'],
    ['ﾓ', 'モ'],
    ['ﾔ', 'ヤ'],
    ['ﾕ', 'ユ'],
    ['ﾖ', 'ヨ'],
    ['ﾗ', 'ラ'],
    ['ﾘ', 'リ'],
    ['ﾙ', 'ル'],
    ['ﾚ', 'レ'],
    ['ﾛ', 'ロ'],
    ['ﾜ', 'ワ'],
    ['ﾝ', 'ン'],
    ['ﾞ', '゛'],
    ['ﾟ', '゜'],
];

const han2zen = new Map<string, string>(han2zenEntries);

const zen2hanEntries: [string, string][] = [
    ...han2zenEntries.map(([han, zen]): [string, string] => [zen, han]),
    ['ヴ', "ｳﾞ"],
    ['ガ', "ｶﾞ"],
    ['ギ', "ｷﾞ"],
    ['グ', "ｸﾞ"],
    ['ゲ', "ｹﾞ"],
    ['ゴ', "ｺﾞ"],
    ['ザ', "ｻﾞ"],
    ['ジ', "ｼﾞ"],
    ['ズ', "ｽﾞ"],
    ['ゼ', "ｾﾞ"],
    ['ゾ', "ｿﾞ"],
    ['ダ', "ﾀﾞ"],
    ['ヂ', "ﾁﾞ"],
    ['ヅ', "ﾂﾞ"],
    ['デ', "ﾃﾞ"],
    ['ド', "ﾄﾞ"],
    ['バ', "ﾊﾞ"],
    ['ビ', "ﾋﾞ"],
    ['ブ', "ﾌﾞ"],
    ['ベ', "ﾍﾞ"],
    ['ボ', "ﾎﾞ"],
    ['パ', "ﾊﾟ"],
    ['ピ', "ﾋﾟ"],
    ['プ', "ﾌﾟ"],
    ['ペ', "ﾍﾟ"],
    ['ポ', "ﾎﾟ"],
];

const zen2han = new Map<string, string>(zen2hanEntries);

export function han2zen_conv(source: string): string {
    let sb = "";
    for (let c of source) {
        let a = han2zen.get(c);
        if (a==undefined) {
            sb += c;
        } else {
            sb += a;
        }
    }
    return sb;
}

export function zen2han_conv(source: string): string {
    let sb = "";
    for (let c of source) {
        let a = zen2han.get(c);
        if (a==undefined) {
            sb += c;
        } else {
            sb += a;
        }
    }
    return sb;
}

export function hira2kata_conv(source: string): string {
    let sb = "";
    for (let i = 0; i < source.length; i++) {
        const c = source.charCodeAt(i);
        if ('ぁ'.charCodeAt(0) <= c && c <= 'ん'.charCodeAt(0)) {
            sb += String.fromCharCode((c - 'ぁ'.charCodeAt(0) + 'ァ'.charCodeAt(0)));
        } else {
            sb += String.fromCharCode(c);
        }
    }
    return sb;
}
